<template>
  <div class="grid lg:grid-cols-3 grid-cols-1 gap-5 mt-12">
    <slot></slot>
  </div>
</template>
